import { create } from 'zustand';
import { IImageGeneration } from '@packages/global';

interface ImageGenerationState {
  // 当前正在进行的生成任务
  activeTasks: Map<string, IImageGeneration>;

  // Actions
  addTask: (task: IImageGeneration) => void;
  updateTask: (taskId: string, updates: Partial<IImageGeneration>) => void;
  removeTask: (taskId: string) => void;
  getTask: (taskId: string) => IImageGeneration | undefined;
  clear: () => void;
}

export const useImageGenerationStore = create<ImageGenerationState>()((set, get) => ({
  activeTasks: new Map(),

  addTask: (task) => {
    console.log('[imageGenerationStore] Adding task:', task.id);
    set((state) => {
      const newTasks = new Map(state.activeTasks);
      newTasks.set(task.id, task);
      return { activeTasks: newTasks };
    });
  },

  updateTask: (taskId, updates) => {
    console.log('[imageGenerationStore] Updating task:', taskId, updates);
    set((state) => {
      const newTasks = new Map(state.activeTasks);
      const existingTask = newTasks.get(taskId);
      if (existingTask) {
        const updatedTask = { ...existingTask, ...updates };
        console.log('[imageGenerationStore] Task updated:', updatedTask);
        newTasks.set(taskId, updatedTask);
      } else {
        console.warn('[imageGenerationStore] Task not found in store:', taskId);
      }
      return { activeTasks: newTasks };
    });
  },

  removeTask: (taskId) => {
    console.log('[imageGenerationStore] Removing task:', taskId);
    set((state) => {
      const newTasks = new Map(state.activeTasks);
      newTasks.delete(taskId);
      return { activeTasks: newTasks };
    });
  },

  getTask: (taskId) => {
    const task = get().activeTasks.get(taskId);
    console.log('[imageGenerationStore] Getting task:', taskId, task);
    return task;
  },

  clear: () => {
    console.log('[imageGenerationStore] Clearing all tasks');
    set({ activeTasks: new Map() });
  }
}));
